<template>
    <div>
        <!-- 补充头部高度空白区域 --> 
		<div class="header_height"></div>
		<div class="header_wrapper">
			<header class="header_box">
				<div class="header_left" @click="$router.push({path:'/'})">
					<img class="header_logo" src="../../static/img/new/index/logo.png" alt=""> 
				</div>
				<div class="header_right">
					<nav class="header_nav_box">
					<!-- <div class="nav_item nav_item_active ">首页</div> -->
	               <!-- <div class="nav_item" >营销资源</div> -->
					<!-- <div class="nav_item">营销案例</div> -->
					<router-link  class="nav_item" active-class="nav_item_active" to="/index">首页</router-link> 
					<router-link  class="nav_item" active-class="nav_item_active" to="/yxzy">营销资源</router-link> 
					<router-link  class="nav_item" active-class="nav_item_active" to="/yxal">营销案例</router-link>
					
					</nav>

					<div class="header_user_info_box">
						<button  type="button" class="haeder_login_btn" v-if="!is_login" @click="login_Visible=true">登录/注册</button> 

						<div  @mouseleave="close_hide_nav" >
							<div class="user_login_box" @mouseenter="open_hide_nav"  v-if="is_login">
								<img class="user_avatar_img" :src="user_info.pic" alt="">
								<span class="up_down_icon"> <i :class="is_show_hide_nav ? 'el-icon-caret-top' : 'el-icon-caret-bottom' "></i>  </span>  
							</div> 
							<div class="login_hide_nav_box" v-if="is_show_hide_nav">

								<div class="login_hide_nav_inner_box">
									<div class="login_hide_nav_item">
									<img class="hide_nav_icon" src="../../static/img/new/index/user_center_icon.png" alt="">
									<div class="nav_title" @click="go_my_page('/my')">个人中心</div> 
								</div>
								<div class="login_hide_nav_item" v-if=" adminApi.user_info && adminApi.user_info.identity == 2">
									<img class="hide_nav_icon" src="../../static/img/new/index/project_icon.png" alt="">
									<div class="nav_title"  @click="go_my_page('/my/my_project')">我的项目</div> 
								</div>
								<div v-if="adminApi.user_info && adminApi.user_info.identity == 2" :class="['login_hide_nav_item',is_tip_message ? 'new_message_tip' : ''] ">
									<img class="hide_nav_icon" src="../../static/img/new/index/down_load_icon.png" alt="">
									<div class="nav_title "  @click="go_my_page('/my/my_resources')">资源下载</div> 
								</div>
								</div>
								
								<div class="logout_item" @click="logout_btn">退出登录</div>
							</div>
						</div>
						
					</div>
				</div>
			</header>   
		</div>

        <!-- 登录注册的弹窗 -->
        <el-dialog class="login_dialog_wrap" :close-on-click-modal="false" :title="login_title" :visible.sync="login_Visible" width="410px" :before-close="colose_login_dialog">
            
            <div class="login_box"> 
                <el-form v-if="login_staus === 1 " :model="login_from"   label-width="100px" class="demo-ruleForm">
                    <!-- 隐藏登录防止账号密码回显 -->
					<div style="opacity: 0;height: 1px;">
						<input class="login_iuput" type="text"  placeholder="请输入您的用户名">
						<input class="login_iuput" type="password"  placeholder="输入登录密码"> 
					</div>  
                    <div class="login_item_box">
                        <div class="login_item_top"> 
                            <img class="mobile_icon" src="../../static/img/new/index/mobile_icon.png" alt="">
                            <div class="login_item_text">手机号码</div>
                        </div>
                        <el-form-item prop="name">
                            <el-input v-model="login_from.mobile" placeholder="请输入手机号码"></el-input>
                        </el-form-item>  
                    </div>	

                    <div class="login_item_box ">
                        <div class="login_item_top"> 
                            <img class="password_icon"  src="../../static/img/new/index/password_icon.png" alt="">
                            <div class="login_item_text" >登录密码</div>
                        </div>
                            <el-form-item prop="name">
                                <el-input v-model="login_from.password" type="password" placeholder="请输入登录密码"></el-input>
                            </el-form-item>  
                    </div>

                    <div class="login_item_box  mar_B_30">
                        <div class="login_item_top"> 
                            <el-checkbox-group v-model="check_password">
                                <el-checkbox label="记住密码" name="type">记住密码</el-checkbox>  
                            </el-checkbox-group>  
                        </div> 
                    </div>

                </el-form>  

                <el-form v-if="login_staus === 2 " :model="register_from"   label-width="100px" class="demo-ruleForm">
                     <!-- 隐藏登录防止账号密码回显 -->
					<div style="opacity: 0;height: 1px;">
						<input class="login_iuput" type="text"  placeholder="请输入您的用户名">
						<input class="login_iuput" type="password"  placeholder="输入登录密码"> 
					</div> 
                    <div class="login_item_box">
                        <div class="login_item_top"> 
                            <img class="login_item_icon" src="../../static/img/new/index/mobile_icon.png" alt="">
                            <div class="login_item_text">手机号码</div>
                        </div>
                        <el-form-item prop="name">
                            <el-input v-model="register_from.mobile" placeholder="请输入手机号码"></el-input>
                        </el-form-item>  
                    </div>	

                    <div class="login_item_box">
                        <div class="login_item_top"> 
                            <img class="login_item_icon" src="../../static/img/new/index/check_code.png" alt="">
                            <div class="login_item_text">手机验证码</div>
                        </div>
                             
                        <el-form-item prop="name" class="send_check_box">
                            <el-input v-model="register_from.code" class="yzm_input" autocomplete="off" placeholder="请输入手机验证码"></el-input>
                            <button type="button" v-if="show_send_register_btn" class="send_check_code" @click="send_register_code">发送验证码</button>
                            <button type="button" v-if="!show_send_register_btn"  class="send_check_code" disabled>{{show_send_register_count}}s后重新获取</button>
                        </el-form-item>  
                            
                    </div>	
 
                    <div class="login_item_box">
                        <div class="login_item_top"> 
                            <img class="login_item_icon"  src="../../static/img/new/index/password_icon.png" alt="">
                            <div class="login_item_text" >设置登录密码</div>
                        </div> 
						<el-form-item prop="name">
							<el-input v-model="register_from.password" type="password"  autocomplete="off" placeholder="请输入登录密码"></el-input>
						</el-form-item>   
                    </div>

                        
                </el-form> 

                <el-form v-if="login_staus === 3 " :model="forget_from"   label-width="100px" class="demo-ruleForm">
                     <!-- 隐藏登录防止账号密码回显 -->
					<div style="opacity: 0;height: 1px;">
						<input class="login_iuput" type="text"  placeholder="请输入您的用户名">
						<input class="login_iuput" type="password"  placeholder="输入登录密码"> 
					</div> 
                    <div class="login_item_box">
                        <div class="login_item_top"> 
                            <img class="login_item_icon" src="../../static/img/new/index/mobile_icon.png" alt="">
                            <div class="login_item_text">手机号码</div>
                        </div>
                        <el-form-item prop="name">
                            <el-input v-model="forget_from.mobile" placeholder="请输入手机号码"></el-input>
                        </el-form-item>  
                    </div>	

                    <div class="login_item_box">
                        <div class="login_item_top"> 
                            <img class="login_item_icon" src="../../static/img/new/index/check_code.png" alt="">
                            <div class="login_item_text">手机验证码</div>
                        </div>
                            
                        
                        <el-form-item prop="name" class="send_check_box">
                            <el-input v-model="forget_from.code" placeholder="请输入手机验证码"></el-input>  
							<button type="button" v-if="show_send_forget_btn" class="send_check_code" @click="send_forget_code">发送验证码</button>
                            <button type="button" v-if="!show_send_forget_btn"  class="send_check_code" disabled>{{show_send_forget_count}}s后重新获取</button>  
                        </el-form-item>  
                            
                    </div>	


                    <div class="login_item_box">
                        <div class="login_item_top"> 
                            <img class="login_item_icon"  src="../../static/img/new/index/password_icon.png" alt="">
                            <div class="login_item_text" >设置新密码</div>
                        </div>
                    
						<el-form-item prop="name">
							<el-input v-model="forget_from.new_password" type="password" placeholder="请输入新密码"></el-input>
						</el-form-item>    
                    </div>

                        
                </el-form>  

            </div>

            <div slot="footer" class="dialog-footer"> 
                <button type="button" class="dialog_login_btn" @click="login_btn" v-if="login_staus === 1 ">登录</button>
                <button type="button" class="dialog_login_btn" @click="register_btn" v-if="login_staus === 2 ">注册</button>
                <button type="button" class="dialog_login_btn" @click="update_password" v-if="login_staus === 3 ">确定</button>
                <div class="forget_box">
                    <span @click="update_login_status(3)" v-if="login_staus !== 3 ">忘记密码？</span>
                    <span @click="update_login_status(2)" v-if="login_staus !== 2 ">注册新账号？</span>
                    <span @click="update_login_status(1)" v-if="login_staus !== 1   ">已有账号去登录</span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script> 
export default {
    name:'Header',
    data(){
        return {
			user_info:{},
			staff_id:'', // 用户id
			is_tip_message:false, // 是否提醒的消息
            is_login: false,      // 是否登录
            login_Visible:false,  // 登录弹窗
            check_password:[],   // 记住密码

			is_show_hide_nav: false,  // 是否显示 登录后的下拉菜单 
			show_send_register_btn:true, // 是否展示 注册 发送验证码按钮 
			show_send_register_count: '', // 是否展示 注册 倒计时
			show_send_register_timer: null,

			show_send_forget_btn:true,  // 是否展示 修改密码 发送验证码按钮 
			show_send_forget_count: '', // 是否展示 修改密码 倒计时
			show_send_forget_timer: null,
			 
            login_title:"登录星工场共享平台", 
            login_staus: 1,      // 弹窗表单状态 1 '登录' || 2 '注册' || 3 '找回密码' 
            // 注册的from
			login_from:{
				mobile: '', 
				password:''
			},
			// 忘记密码
			forget_from:{
				mobile: '',
				code:'',
				new_password:''
			},

			// 注册的from
			register_from:{
				mobile: '',
				code:'',
				password:''
			}
        }
    },
	mounted() {  
		this.$bus.$on('show_login_dialog',()=>{
			this.login_Visible = true
		}) 
        let staff_id =  localStorage.getStorageWithAge('staff_id')   
		if(staff_id){ 
			// 改变登录状态
			this.is_login = true 
			// let user_info =  JSON.parse(localStorage.getItem('user_info')) || {} 
			// if(user_info.name){ 
			// 	this.user_info = user_info  
			// 	this.adminApi.user_info = user_info  
			// }else{
			// 	// 获取用户信息
			// 	this.get_user_info()
			// }  
			// 获取用户信息
			this.staff_id = staff_id
			this.get_user_info()
			// 刷新页面时 判断是否显示小红点
			this.find_is_tip_message(staff_id)
		}else{ 
			//清除缓存信息
			localStorage.removeItem('user_info');  
			localStorage.removeItem('staff_id');   
		}
        
		
	},
    methods: { 

		// 关闭弹窗修改状态
		colose_login_dialog(){ 
			this.login_Visible = false
			setTimeout(()=>{  
				this.update_login_status(1)
			},500)
			
		},
 
          
		// 获取用户信息
        async get_user_info(type){  

			let cache_user_info =  JSON.parse(localStorage.getItem('user_info')) || {} 
		  
			let {info} = await this.axios.post("/User/info",{staff_id:this.staff_id})   
			info.staff_id = this.staff_id  
			// 设置全局用户信息
			localStorage.setItem('user_info',JSON.stringify(info))  
			this.user_info = info  
			this.adminApi.user_info = info    
			// 改变登录状态
			this.is_login = true
			// 提出注册成功
			// this.$message.success('登录成功') 
			if(cache_user_info.identity && cache_user_info.identity != info.identity){
	           this.$router.push({path: '/'});
			   location.reload() 
			}else if(type){
				// 刷新当前页
				location.reload() 
			}
 
        },

		// 刷新页面时 判断是否显示小红点
		async find_is_tip_message(staff_id){
  			let {count} = await this.axios.post("/Message/get_message_count",{staff_id})    
			this.is_tip_message = count > 0 
		},
  
		// 修改密码
		update_password(){
			 let {mobile,code,new_password} = this.forget_from
		   if(!mobile){
			   return this.$message.error('手机号码不能为空') 
		    }
		    if(!(/^1[3456789]\d{9}$/.test(mobile))){  
				return this.$message.error('请输入正确的手机号码') 
			} 
 
		    if(!code){
			   return this.$message.error('验证码不能为空') 
		    }

			if(!new_password){
			   return this.$message.error('新密码不能为空') 
		    }

			this.axios.post("/Login/reset_password",{...this.forget_from}).then(res=>{ 
				// 清空数据
				this.forget_from.mobile = ''
				this.forget_from.code = ''
				this.forget_from.new_password = ''
	            this.show_send_forget_btn = true   
				this.show_send_forget_count = ''  
				this.show_send_forget_timer = null
				// 关闭弹窗 
				this.login_Visible = false  
				this.update_login_status(1)
				// 提出注册成功
			    this.$message.success('修改成功')  
 
			}).catch(err=>{
			    this.$message.error(err)  
			})
		},
 
		// 发送修改密码验证码
		send_forget_code(){ 
			const TIME_COUNT = 60;
			let {mobile} = this.forget_from
			if(!mobile){
			   return this.$message.error('手机号码不能为空') 
		    }
		    if(!(/^1[3456789]\d{9}$/.test(mobile))){  
				return this.$message.error('请输入正确的手机号码') 
			} 
		   
 			this.axios.post("/Mobile/send_sms",{mobile}).then(res=>{
				if (!this.show_send_forget_timer) {
					this.show_send_forget_count = TIME_COUNT;
					this.show_send_forget_btn = false;
					this.show_send_forget_timer = setInterval(() => {
						if (this.show_send_forget_count > 0 && this.show_send_forget_count <= TIME_COUNT) {
							this.show_send_forget_count--;
						} else {
							this.show_send_forget_btn = true;
							clearInterval(this.show_send_forget_timer);
							this.show_send_forget_timer = null;
						}
					}, 1000)
				} 
			}).catch(err=>{
			   this.$message.errors(err) 
			})

			
		},

		//  退出登录
		logout_btn(){
			//1,设置值到data 
			this.adminApi.user_info = {}; 
			this.user_info = {}

			//清除缓存信息
			localStorage.removeItem('user_info');  
			localStorage.removeItem('staff_id');  

			// 改变登录状态
			this.is_login = false
			// 刷新当前页面
			// this.close_hide_nav()
            this.$router.push({path: '/'});

			// 刷新当前页
			location.reload()
		
		},

		// 去个人中心页面
		go_my_page(url){
 			this.$router.push({
				path: url
			}); 
			this.close_hide_nav()
		},

		// 登录
		login_btn(){  
 			let {mobile,password} = this.login_from
			if(!mobile){
			   return this.$message.error('手机号码不能为空') 
		    }
		    if(!(/^1[3456789]\d{9}$/.test(mobile))){  
				return this.$message.error('请输入正确的手机号码') 
			}  
		    if(!password){
			   return this.$message.error('密码不能为空') 
		    }
			this.axios.post("/Login/mobile_login",{...this.login_from}).then(res=>{ 
				 
				// 清空数据
				this.login_from.mobile = '' 
				this.login_from.password = '' 
				// 关闭弹窗 
				this.login_Visible = false  
			
				this.user_info = res.data 
				//  判断 是否勾选记住密码 设置过期时间   
				if(this.check_password.length){ 
					// 记住密码 设置 1 周
					localStorage.setStorageWithAge('staff_id', res.data.staff_id,60 * 60 * 24 * 7) 
				}else{
					// 不勾选记住密码 设置1天
					localStorage.setStorageWithAge('staff_id', res.data.staff_id,60 * 60 * 24) 
				} 

				this.staff_id = res.data.staff_id
				// 登录成功 获取用户信息
				this.get_user_info(true)  
				
				
				
			}).catch(err=>{
				return this.$message.error(err)  
			})

		},

		// 注册
	    register_btn(){
           let {mobile,code,password} = this.register_from
		   if(!mobile){
			   return this.$message.error('手机号码不能为空') 
		    }
		    if(!(/^1[3456789]\d{9}$/.test(mobile))){  
				return this.$message.error('请输入正确的手机号码') 
			} 
 
		    if(!code){
			   return this.$message.error('验证码不能为空') 
		    }

			if(!password){
			   return this.$message.error('密码不能为空') 
		    }

			this.axios.post("/Login/register",{...this.register_from}).then(res=>{ 
				// 清空数据
				this.register_from.mobile = ''
				this.register_from.code = ''
				this.register_from.password = ''
	            this.show_send_register_btn = true   
				this.show_send_register_count = ''  
				this.show_send_register_timer = null
				// 关闭弹窗 
				this.login_Visible = false 
				this.update_login_status(1) 
				// 提出注册成功
				return this.$message.success('注册成功')  
				 
			}).catch(err=>{
				return this.$message.error(err)  
			})
  
 
		},



		// 发送注册验证码
		send_register_code(){ 
			const TIME_COUNT = 60;
			let {mobile} = this.register_from
			if(!mobile){
			   return this.$message.error('手机号码不能为空') 
		    }
		    if(!(/^1[3456789]\d{9}$/.test(mobile))){  
				return this.$message.error('请输入正确的手机号码') 
			} 

		    this.axios.post("/Mobile/send_sms",{mobile}).then(res=>{
				if (!this.show_send_register_timer) {
					this.show_send_register_count = TIME_COUNT;
					this.show_send_register_btn = false;
					this.show_send_register_timer = setInterval(() => {
						if (this.show_send_register_count > 0 && this.show_send_register_count <= TIME_COUNT) {
							this.show_send_register_count--;
						} else {
							this.show_send_register_btn = true;
							clearInterval(this.show_send_register_timer);
							this.show_send_register_timer = null;
						}
					}, 1000)
				} 
			}).catch(err=>{
				this.$message.errors(err) 
			})


			
		},
		  
        open_hide_nav(){ 
            this.is_show_hide_nav = true
        },

        close_hide_nav(){
            this.is_show_hide_nav = false
        },

        update_login_status(login_staus){
            this.login_staus = login_staus
			if(login_staus == 1){
   				this.login_title = "登录星工场共享平台" 
			}else if(login_staus == 2){
				this.login_title = "注册账号" 
			}else if(login_staus == 3){
   				this.login_title = "找回密码" 
			}
        },
        
		 
    },
}
</script>

<style scoped>

/* 登录的弹窗样式 */
 

.login_dialog_wrap  >>> .el-checkbox__input.is-focus .el-checkbox__inner {
	border-color: #C0C4CC; 
}
.login_dialog_wrap  >>> .el-checkbox__inner:hover {
    border-color: #E61B64;
}
 
.login_dialog_wrap  >>> .el-checkbox__input.is-checked .el-checkbox__inner,
.login_dialog_wrap  >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #E61B64;
    border-color: #E61B64;
}

.login_dialog_wrap  >>> .el-checkbox__input.is-checked+.el-checkbox__label {
	color: #1A1A1A;
	font-weight: 600;
} 


.login_dialog_wrap >>>  .el-input__inner:focus {
    border-color: #C0C4CC;
}

.login_dialog_wrap >>> .el-dialog{ 
    border-radius: 20px !important;
}

.login_dialog_wrap >>> .el-dialog__title {
	font-size: 20px; 
	font-weight: 600;
	color: #1A1A1A;
}

.login_item_box >>> .el-form-item__content {
	margin-top: 10px;
	margin-left: 0 !important; 
	display: flex;
    justify-content: space-between;
    width: 100%;
}

.login_dialog_wrap >>>.el-dialog__footer{
	text-align: center;
}

.dialog_login_btn{
	width: 349px;
	height: 50px;
	line-height:50px;
	background: #E61B64;
	border-radius: 25px;
	font-size: 16px; 
	font-weight: 500;
	color: #FFFFFF; 
}

.forget_box{
	margin-top: 23px;
	font-size: 12px; 
	color: #1A1A1A;
	cursor: pointer;
}

.forget_box span:nth-child(1){
	border-right: 1px solid #999999;
	margin-right: 5px;
	padding-right: 5px;
	
}

.login_item_box .login_item_top{
	display: flex;
	align-items: center;
} 

.login_item_box .login_item_top .login_item_icon {
	width: 16px;
	margin-right: 7px;
}

.login_item_box .login_item_top .login_item_text {
	font-size: 13px; 
	color: #1A1A1A;
	font-weight: 600;
}

.send_check_box {
	display: flex;
	align-items: center;
}

.login_dialog_wrap >>> .el-input,
.login_dialog_wrap >>> .el-input__inner{
	height: 50px !important;
	font-size: 14px; 
	color: #333;
	font-weight: bold;
}

.login_dialog_wrap >>> .el-input__inner::placeholder{
	color: #C0C3C6;
	font-weight: normal;
}

.login_dialog_wrap >>> .el-dialog__body {
	/* padding-bottom:  0 !important; */
	padding: 0 30px;
}

.send_check_code {
	width: 160px;
	height: 50px;
	background: rgba(252,232,239,.6);
	border-radius: 6px; 
	font-size: 14px; 
	font-weight: 600;
	color: #E61B64;
	margin-left: 10px;
}

.login_dialog_wrap >>> .el-dialog__header {
	padding: 25px 30px 36px;
}

.login_dialog_wrap .login_item_top .mobile_icon, 
.login_dialog_wrap .login_item_top .password_icon{
	width: 14px;
	height: 14px;
	margin-right: 7px;
}

/* 登录的弹窗结束 */



/* 头部开始 */
.header_height{
	height: 70px;
}
.header_wrapper {
    position: fixed;
	top: 0;  
	z-index: 1999;
	background-color: #fff;
	height: 70px;
	line-height: 70px; 
	width: 100%;
	box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.05);  
}

.header_box { 
	display: flex;
    justify-content: space-between; 
	width: 1200px;
	margin: 0 auto;
}

.header_nav_box,
.header_right {
	display: flex;
}

.header_nav_box {
	height: 55px;
}
 
.header_nav_box .nav_item { 
	font-size: 16px; 
	font-weight: 500;
	color: #1A1A1A;  
	margin-right: 70px;
	text-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
	position: relative;
	cursor: pointer;
}

.header_nav_box .nav_item_active{
	color: #E61B64;   
} 

.nav_item_active::after{
	content: '';
	display: inline-block; 
	width: 100%;
	height: 4px;
	background: #E61B64; 
	border-radius: 2px; 
	position: absolute;
	bottom: 0;
	right: 0;
}  

.haeder_login_btn{
	width: 110px;
	height: 36px;
	background: #E61B64;
	box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.05);
	border-radius: 19px;
	font-size: 14px; 
	font-weight: 500;
	color: #FFFFFF;
}
 
 .header_left{
	 display: flex;
	 align-items: center;
	 cursor: pointer;
 }
 .header_left .header_logo {
	 width: 160px;
	 height: 38px;
 }

  .header_user_info_box  {
	  position: relative;
	  cursor: pointer;
  }

 .header_user_info_box .user_login_box {
	 display: flex;
	 align-items: center;
 }	
  .header_user_info_box .user_login_box .user_avatar_img{
	width: 40px;
	height: 40px;
	box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.05);
	border-radius: 20px;
	margin-right: 9px;
  }
   .header_user_info_box .user_login_box .up_down_icon {
	   font-size: 22px;
	   color: #999;
  }

.header_user_info_box  .login_hide_nav_box {
	position: absolute;
	right: 0;
	width: 180px; 
	background: #FFFFFF;
	box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.1);
	border-radius: 10px;
	border: 1px solid rgba(192, 195, 198, 0.37);
	padding-top: 10px;
    box-sizing: border-box;
	top: 60px;
  }

  .header_user_info_box .login_hide_nav_inner_box {
	  padding: 0 10px;
	  margin-bottom: 10px;
  }

  .header_user_info_box  .login_hide_nav_box  .login_hide_nav_item{
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  cursor: pointer;
	  height: 50px; 
	  position: relative;  
  }
  
.header_user_info_box  .login_hide_nav_box  .login_hide_nav_item:hover {
	background: #F8F9FA; 
}

  .header_user_info_box  .login_hide_nav_box  .login_hide_nav_item.new_message_tip::after{
	content: '';
	display: block;
	position: absolute;
	width: 7px;
	height: 7px;
	background: #E61B64;
	border-radius: 4px;
	right: 23px;
    top: 13px;
  }

  .header_user_info_box  .login_hide_nav_box  .login_hide_nav_item .hide_nav_icon{
	  width: 18px;
	  height: 18px;
	  margin-right: 13px;
  }

 .header_user_info_box .logout_item {
	border-top: 1px solid  rgba(192, 195, 198, 0.5); 
	font-size: 14px; 
	font-weight: 600;
	color: #8A8E93; 
	text-align: center;
	line-height: 50px;
    /* margin-top: 18px; */
	cursor: pointer;
  }

  /* .header_user_info_box .logout_item:hover {
	background: #F8F9FA; 
} */

/* 头部结束 */ 

</style>



// WEBPACK FOOTER //
// src/components/header.vue